import React, { useEffect, useState, useRef } from 'react';
import parse from 'html-react-parser';
import { storage, ref, uploadBytesResumable, getDownloadURL, deleteObject } from '../../../config/firebaseConfig.js'; // Pastikan import benar
import Compressor from 'compressorjs';

const EditSoal = ({
    editData,
    informasiAkun,
    onSave,
    onCancle


}) => {

    const [jenis, setJenis] = useState(""); // Untuk menyimpan jenis jawaban
    const [jawaban, setJawaban] = useState([]); // Array jawaban
    const [datasoal, setDataSoal] = useState([]); // Array jawaban


    const [isBold, setIsBold] = useState(false); // Untuk memantau apakah bold aktif
    const [isItalic, setisItalic] = useState(false); // Untuk memantau apakah bold aktif
    const [isUnderline, setIsUnderline] = useState(false); // Status Underline
    const [isList, setisList] = useState(false); // Status Underline
    const [isListNumber, setListNumber] = useState(false); // Status Underline
    const [editors, setEditors] = useState(["text-editor-edit"]);
    var editor = document.getElementById("text-editor-edit");


    const progressRef = useRef(0);
    const [isLoading, setIsLoading] = useState(false);
    const prevImagesRef = useRef([]); // Untuk menyimpan gambar sebelumnya
    const handleBold = () => {
        const isCurrentlyBold = document.queryCommandState("bold");
        setIsBold(!isCurrentlyBold); // Toggle status Bold
        document.execCommand("bold"); // Mengatur teks menjadi bold
    };

    const handleItalic = () => {
        const isCurrentlyItalic = document.queryCommandState("italic");
        setisItalic(!isCurrentlyItalic);
        document.execCommand("italic"); // Mengatur teks menjadi italic
    };

    const handleUnderline = () => {
        const isCurrentlyunderline = document.queryCommandState("underline");
        setIsUnderline(!isCurrentlyunderline); // Toggle status Underline
        document.execCommand("underline"); // Mengatur teks menjadi underline
    };

    const handleList = () => {
        const isCurrentinsertUnorderedList = document.queryCommandState("underlinsertUnorderedListine");

        setisList(!isCurrentinsertUnorderedList); // Toggle status List
        document.execCommand("insertUnorderedList"); // Menambahkan daftar tak berurut
    };

    const handleOrderedList = () => {
        const isCurrentinsertOrderedList = document.queryCommandState("insertOrderedList");

        setListNumber(!isCurrentinsertOrderedList); // Toggle status List Numbered
        document.execCommand("insertOrderedList"); // Menambahkan daftar berurut
    };
   
    const handleInput = (e) => {

        // Mendapatkan elemen editor
        const anchorTags = editor.querySelectorAll("a");
        anchorTags.forEach((anchor) => {
            const parent = anchor.parentNode;
            while (anchor.firstChild) {
                parent.insertBefore(anchor.firstChild, anchor);
            }
            parent.removeChild(anchor);
        });
        // Mengambil semua tag gambar di dalam editor
        const imgTags = editor.querySelectorAll("img");
        const currentImages = Array.from(imgTags).map(img => img.getAttribute("src"));

        // Periksa gambar yang dihapus (jika ada) dan hapus dari Firebase
        prevImagesRef.current.forEach((imgSrc) => {
            if (!currentImages.includes(imgSrc)) {
                deleteImageFromFirebase(imgSrc);
            }
        });

        // Update gambar yang tersisa untuk referensi berikutnya
        prevImagesRef.current = currentImages;

        // Menangani format teks
        if (!editor.textContent) {
            // Mengambil status format teks yang terblok
            const isCurrentlyBold = document.queryCommandState("bold");
            const isCurrentlyItalic = document.queryCommandState("italic");
            const isCurrentlyUnderline = document.queryCommandState("underline");
            const isCurrentlyList = document.queryCommandState("insertUnorderedList");
            const isCurrentlyOrderedList = document.queryCommandState("insertOrderedList");

            console.log(isCurrentlyBold)

            // Mengubah status format teks berdasarkan kondisi
            if (isBold !== isCurrentlyBold) {

                document.execCommand("bold");
            }
            if (isItalic !== isCurrentlyItalic) {
                document.execCommand("italic");
            }
            if (isUnderline !== isCurrentlyUnderline) {
                document.execCommand("underline");
            }
            if (isList !== isCurrentlyList) {
                document.execCommand("insertUnorderedList");
            }
            if (isListNumber !== isCurrentlyOrderedList) {
                document.execCommand("insertOrderedList");
            }
        }
    };
        const isImageUrl = (url) => {
            // Pola regex untuk mendeteksi URL gambar
            const imageUrlPattern = /\.(jpeg|jpg|gif|png|svg)$/i;
            return imageUrlPattern.test(url); // Mengembalikan true jika URL sesuai dengan pola gambar
        };


        useEffect(() => {
            editors.forEach((editorId) => {
                const editor = document.getElementById(editorId);
                if (editor) {
                    editor.addEventListener('paste', handlePaste);
                }
            });
            console.log(editors)
    
            // Bersihkan event listener saat komponen di-unmount atau saat editor baru ditambahkan
            return () => {
                editors.forEach((editorId) => {
                    const editor = document.getElementById(editorId);
                    if (editor) {
                        editor.removeEventListener('paste', handlePaste);
                    }
                });
            };
        }, [editors]);
    const handlePaste = (event) => {
        event.preventDefault(); // Mencegah aksi default paste
        let isImagePasted = false;
        const target = event.currentTarget.id
        const clipboardItems = event.clipboardData.items;
        const clipboardText = event.clipboardData.getData("text/plain"); // Dapatkan teks dari clipboard

        // Mengecek apakah yang di-paste adalah URL gambar
        if (isImageUrl(clipboardText)) {
            isImagePasted = true;
            insertImageToEditor(clipboardText, target);
        } else {
            isImagePasted = false;
            for (let i = 0; i < clipboardItems.length; i++) {
                const item = clipboardItems[i];

                if (item.type.indexOf("image") !== -1) {
                    // Jika item adalah gambar, simpan ke Firebase Storage
                    const file = item.getAsFile();
                    handleUpload(file, target);
                    break;
                }
            }
        }

        if (!isImagePasted) {
            document.execCommand("insertText", false, clipboardText);
        }

    };
    const handlePilihFile = (e, target) => {
        e.preventDefault();
        const fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.accept = "image/*"; // Hanya gambar
        fileInput.onchange = (e) => {
            const file = e.target.files[0];
            if (file) {

                handleUpload(file, target);
            }
        };
        fileInput.click(); // Memicu dialog pemilih file
    };

   const handleUpload = (image, lokasi) => {
          if (!image) return;
              // Cek ukuran gambar
              if (image.size > 5 * 1024 * 1024) { // Jika lebih dari 5MB
                  new Compressor(image, {
                      quality: 0.6, // Kompresi kualitas
                      maxWidth: 1920, // Maksimum lebar
                      maxHeight: 1080, // Maksimum tinggi
                      success: (compressedFile) => {
                          console.log("Gambar dikompresi:", compressedFile);
                          uploadToFirebase(compressedFile, lokasi);
                      },
                      error: (err) => {
                          console.error("Kompresi gagal:", err);
                      },
                  });
              } else {
                  uploadToFirebase(image, lokasi);
              }
         
      };
      const uploadToFirebase = (image, lokasi) => {
  
          const storageRef = ref(storage, informasiAkun.wa_number + '/imgsoaljawaban/' + image.name);
          const uploadTask = uploadBytesResumable(storageRef, image);
  
  
          uploadTask.on(
              'state_changed',
              (snapshot) => {
                  const prog = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                  setIsLoading(true);
                  const load = document.getElementById("loadimg");
  
  
                  // Menampilkan progress pada elemen
                  load.innerText = `${prog.toFixed(2)}%`; // Menampilkan nilai progress dalam bentuk persen dengan 2 angka di belakang koma
  
                  // Memperbarui lebar progress bar
                  load.style.width = `${prog}%`;
                  load.setAttribute('aria-valuenow', prog); // Memperbarui nilai aria-valuenow
  
                  // Menampilkan progress bar container jika ada upload
                  // load.style.display = 'block';
              },
              (error) => {
                  console.error("Error uploading file: ", error);
                  setIsLoading(false);
              },
  
              () => {
                  getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                      insertImageToEditor(downloadURL, lokasi);
                      console.log("File available at: ", downloadURL);
                      prevImagesRef.current.push(downloadURL)
                      setIsLoading(false);
                      console.log(prevImagesRef)
                  });
              }
          );
          if (!uploadTask) {
              setIsLoading(true);
          } else {
              setIsLoading(false);
          }
      }

    const insertImageToEditor = (imageSrc, target) => {
        const editor = document.getElementById(target);
        if (editor) {
            const br = document.createElement("br");
            editor.appendChild(br);

            const img = document.createElement("img");
            img.src = imageSrc;
            img.style.maxWidth = "100%"; // Membatasi ukuran gambar
            img.style.margin = "10px 0"; // Memberi jarak antar teks dan gambar
            editor.appendChild(img); // Tambahkan gambar ke editor
            editor.appendChild(br);
        }
    };
    // Fungsi untuk menghapus gambar dari Firebase Storage
    const deleteImageFromFirebase = (imageUrl) => {
        // Ambil hanya path file dari URL yang diberikan
        const filePath = decodeURIComponent(imageUrl.split('?')[0].replace('https://firebasestorage.googleapis.com/v0/b/smartschool-c87d3.appspot.com/o/', ''));

        // Buat referensi ke file di Firebase Storage
        const imageRef = ref(storage, filePath);

        // Coba hapus gambar
        deleteObject(imageRef)
            .then(() => {
                console.log(`Gambar ${imageUrl} berhasil dihapus dari Firebase Storage`);
            })
            .catch((error) => {
                console.error(`Gagal menghapus gambar ${imageUrl} dari Firebase Storage`, error);
            });
    };
    const handleJenisChange = (type) => {
        setJenis(type);

        setJawaban(prev => {
            // Jika jawaban kosong, tambahkan satu jawaban default
            if (prev.length === 0) {
                return [{ id_jwb: 1, text: "", checked: false }];
            }
            // Jika memilih radio, pastikan hanya satu yang dicentang
            if (type === "objectif") {
                return prev.map((item, index) => ({
                    ...item,
                    checked: index === 0 // Hanya item pertama yang dicentang
                }));
            } else {
                // Jika kembali ke checkbox, tetap biarkan data seperti sebelumnya
                return prev.map(item => ({ ...item, kunci: false }));
            }
        });
        console.log(type)
    };


    const handleAddJawaban = () => {
        const newId = jawaban.length + 1; // ID baru berdasarkan jumlah elemen dalam array
        setJawaban([...jawaban, { id_jwb: newId, text: "", kunci: 0 }]);
    };
    const handleJawabanChange = (id, value) => {
        const selection = window.getSelection();
        const range = selection.getRangeAt(0);
        const startOffset = range.startOffset;

        setJawaban(prev =>
            prev.map(item => (item.id_jwb === id ? { ...item, text: value } : item))
        );

        setTimeout(() => {
            const newDiv = document.getElementById(`jwbobjektifedit${id}`);
            if (newDiv) {
                const newRange = document.createRange();
                newRange.setStart(newDiv.childNodes[0], startOffset);
                newRange.collapse(true);
                selection.removeAllRanges();
                selection.addRange(newRange);
            }
        }, 0);
    };

    const handleCheckboxChange = (id) => {
        setJawaban(prev =>
            prev.map(item => (item.id_jwb === id ? { ...item, kunci: !item.kunci === true ? 1 : 0 } : item))
        );
    };

    const handleRadioboxChange = (id) => {
        setJawaban(prev =>
            prev.map(item => ({
                ...item,
                kunci: item.id_jwb === id ? 1 : 0 // Set kunci menjadi 1 untuk id yang dipilih, yang lainnya menjadi 0
            }))
        );
    };
    const handleSaveSoal = () => {
        let soalText = document.getElementById("text-editor-edit").innerHTML;
        let poin = document.getElementById("poinedit").value;

        if (!soalText.trim()) {
            alert("Soal tidak boleh kosong!");
            return;
        }

        // Perbarui jawaban dengan isi terbaru dari contentEditable
        setJawaban(prevJawaban => {
            const updatedJawaban = prevJawaban.map((item, index) => ({
                ...item,
                text: document.getElementById(jenis + index)?.innerHTML || item.text
            }));

            // Setelah `setJawaban` selesai, buat `newSoal`
            const newSoal = {
                poin: poin,
                id_mapel: datasoal.id_mapel,
                id_rombel: datasoal.id_rombel,
                pembelajaran_id: datasoal.pembelajaran_id,
                nama_rombel: datasoal.nama_rombel,
                soal: soalText,
                jenis: jenis,
                jawaban: jenis === "essay" ? [] : updatedJawaban,
                createdAt: new Date() // Menyimpan timestamp
            };

            // Kirim data yang sudah diubah ke parent
            onSave(newSoal, datasoal.id);
            console.log(newSoal)

            return updatedJawaban; // Kembalikan state terbaru
        });
    };
    const ubahpoin = (e) => {
        setDataSoal({ ...datasoal, poin: e.target.value }

        )

        console.log(e.target.value)
    }
    useEffect(() => {

        setDataSoal(editData)
        setJenis(editData.jenis)
        setJawaban(editData.jawaban)
        console.log(editData)

    }, []);

    return (
        <div className="col-sm-12 col-md-12  col-xl-12" id={editData.id}>
            <div className="card">
                <div className="card-body">
                    <div className="row justify-content-between align-items-center"><h4 className='col'>Soal Edit</h4>

                        <div className="row col-auto ">
                            <div className="col-sm-3 col-md-3 col-xl-3" id="baru">
                                <input type="number" id="poinedit" className="form-control" onChange={ubahpoin} placeholder="Poin" value={datasoal.poin} />
                            </div>
                            <div className="col-sm-4 col-md-4 col-xl-4" id="baru">
                                <button className='col-auto btn btn-warning' type='button' onClick={onCancle}><i className='ti ti ti-x'></i> Batal</button>
                            </div>
                            <div className="col-sm-4 col-md-4 col-xl-4" id="baru">
                                <button className='col-auto btn btn-primary' type='button' onClick={handleSaveSoal}><i className='ti ti-file-symlink'></i> Simpan</button>

                            </div>
                        </div>

                    </div>
                    <div className="row g-4">
                        <div className="col-md-12">
                            <div className='d-flex flex-wrap gap-2 mb-4'>
                                <button type="button" onClick={handleBold} className={`btn btn-icon btn-outline-dark ${isBold ? "active" : ""}`} ><i className="ti ti-Bold"></i></button>
                                <button type="button" onClick={handleItalic} className={`btn btn-icon btn-outline-dark ${isItalic ? "active" : ""}`}><i className="ti ti-Italic"></i></button>
                                <button type="button" onClick={handleUnderline} className={`btn btn-icon btn-outline-dark ${isUnderline ? "active" : ""}`}><i className="ti ti-underline"></i></button>
                                <button type="button" onClick={handleList} className={`btn btn-icon btn-outline-dark ${isList ? "active" : ""}`}><i className="ti ti-list"></i></button>
                                <button type="button" onClick={handleOrderedList} className={`btn btn-icon btn-outline-dark ${isListNumber ? "active" : ""}`}><i className="ti ti-list-numbers"></i></button>
                                <button type="button" onClick={(e) => handlePilihFile(e, "text-editor-edit")} className="btn btn-icon btn-outline-dark"><i className="ti ti-photo"></i></button>
                            </div>
                            <div>
                                <div className="progress mb-4" style={{ height: "20px", display: isLoading ? 'block' : 'none', }}>
                                    <div id='loadimg'
                                        className="progress-bar"
                                        role="progressbar"
                                        style={{}}
                                        aria-valuenow={progressRef.current}
                                        aria-valuemin="0"
                                        aria-valuemax="100">
                                        {progressRef.current} %
                                    </div>
                                </div>
                            </div>
                            <div
                                id="text-editor-edit"
                                className='editor'
                                contentEditable
                                style={{ minHeight: '50px', borderBottom: '1px solid #ccc', padding: '10px' }}
                                onInput={handleInput}
                                suppressContentEditableWarning={true}

                            ><div dangerouslySetInnerHTML={{ __html: datasoal.soal }} /></div>
                        </div>
                        <div className="col-md-12">

                            <div className="btn-group dropstart">
                                <button type="button" className="btn btn-light-secondary">
                                    Jenis Jawaban
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-light-secondary dropdown-toggle dropdown-toggle-split"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    <span className="visually-hidden">Toggle Dropdown</span>
                                </button>
                                <div className="dropdown-menu">
                                    <button
                                        className="dropdown-item"
                                        onClick={() => handleJenisChange("objectif")}
                                    >
                                        Jawaban Ganda
                                    </button>
                                    <button
                                        className="dropdown-item"
                                        onClick={() => handleJenisChange("ganda")}
                                    >
                                        Ceklis
                                    </button>
                                    <button
                                        className="dropdown-item"
                                        onClick={() => handleJenisChange("essay")}
                                    >
                                        Esay
                                    </button>
                                </div>
                            </div>

                            <div className="mt-4">
                                {/* Render berdasarkan jenis jawaban */}
                                {jenis === "objectif" && (
                                    <div>
                                        <h5>Jawaban Ganda (Radio)</h5>
                                        {jawaban.map((item, index) => (
                                            <div key={index} className="d-flex align-items-center mb-2 col-md-12">
                                                <div className="input-group mb-3">
                                                    <span className="input-group-text">
                                                        <input
                                                            checked={item.kunci === 1 ? true : false}
                                                            onChange={() => handleRadioboxChange(item.id_jwb)}
                                                            className="form-check-input input-light-primary" name='jawaban[]' type="radio" id="customCheckclight1" />
                                                    </span>
                                                    <span className="input-group-text">
                                                        <button type="button" onClick={(e) => handlePilihFile(e, jenis + index)} className="btn btn-icon btn-outline-dark"><i className="ti ti-photo"></i></button>
                                                    </span>

                                                    <div
                                                        id={jenis + index}
                                                        className="form-control editor"
                                                        contentEditable
                                                        style={{ minHeight: '50px', borderBottom: '1px solid #ccc', padding: '10px' }}

                                                        suppressContentEditableWarning={true}

                                                        dangerouslySetInnerHTML={{ __html: item.text }}
                                                    ></div>

                                                </div>
                                            </div>
                                        ))}
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary"
                                            onClick={handleAddJawaban}
                                        >
                                            Tambah Jawaban
                                        </button>
                                    </div>
                                )}

                                {jenis === "ganda" && (
                                    <div>
                                        <h5>Ceklis (Checkbox)</h5>
                                        {jawaban.map((item, index) => (
                                            <div key={index} className="d-flex align-items-center mb-2 col-md-12">
                                                <div className="input-group mb-3">
                                                    <span className="input-group-text">
                                                        <input
                                                            checked={item.kunci === 1 ? true : false}
                                                            onChange={() => handleCheckboxChange(item.id_jwb)}
                                                            className="form-check-input input-light-primary" name='jawaban[]' type="checkbox" id="customCheckclight1" />
                                                    </span>
                                                    <span className="input-group-text">
                                                        <button type="button" onClick={(e) => handlePilihFile(e, jenis + index)} className="btn btn-icon btn-outline-dark"><i className="ti ti-photo"></i></button>
                                                    </span>

                                                    <div
                                                        id={jenis + index}
                                                        className="form-control editor"
                                                        contentEditable
                                                        style={{ minHeight: '50px', borderBottom: '1px solid #ccc', padding: '10px' }}

                                                        suppressContentEditableWarning={true}
                                                        dangerouslySetInnerHTML={{ __html: item.text }}


                                                    ></div>
                                                </div>
                                            </div>

                                        ))}
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary"
                                            onClick={handleAddJawaban}
                                        >
                                            Tambah Jawaban
                                        </button>
                                    </div>
                                )}
                                {jenis === "essay" && (
                                    <div>
                                        <h5>Essay Jawaban, Jawaban isi untuk menjadi pedoman dan update fitur koreksi otomatis dimasa depan</h5>
                                        {jawaban.map((item, index) => (
                                            <div
                                                id={jenis + index}
                                                className="form-control editor"
                                                contentEditable
                                                style={{ minHeight: '50px', borderBottom: '1px solid #ccc', padding: '10px' }}

                                                suppressContentEditableWarning={true}
                                                dangerouslySetInnerHTML={{ __html: item.text }}
                                            ></div>
                                        ))}

                                    </div>
                                )}
                            </div>
                        </div>

                    </div>
                </div>
                <div className="card-footer">
                    <div className="row justify-content-between align-items-center"><h4 className='col'>Tindakan</h4>
                        <button className='col-auto btn btn-warning' type='button' onClick={onCancle}><i className='ti ti ti-x'></i> Batal</button>

                        <button className='col-auto btn btn-primary' type='button' onClick={handleSaveSoal}><i className='ti ti-file-symlink'></i> Simpan</button></div>
                </div>
            </div>
        </div>
    );
};

export default EditSoal;